import axios from "axios";

// ── A QUE SERVIDOR HABLA ESTE CLIENTE ───────────────────────────────────────
//
// Antes esto era:
//
//     const BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:8000";
//
// Sin la variable, TODO lo que pasa por aqui se iba a `localhost:8000` — un
// puerto que en NSL no usa nadie, ni en desarrollo (el proxy de Vite apunta al
// 8002) ni desde luego en produccion. Es decir: el respaldo no respaldaba nada,
// solo convertia una variable olvidada en un error de red sin explicacion.
//
// Ahora, vacio: rutas relativas `/api/...`, como el resto de la aplicacion.
// En desarrollo las recoge el proxy de Vite; en produccion, el reenvio de
// `vercel.json` hacia Render. Y como la llamada sale al MISMO origen que la
// pagina, deja de haber CORS de por medio.
//
// Eso ultimo no es un detalle: el 24-09-2026, al estrenar el dominio, el login
// dejo de funcionar porque `VITE_API_URL` estaba puesta en Vercel y la llamada
// salia cruzada al backend, que rechazo el origen nuevo. Con ruta relativa ese
// fallo no puede volver a ocurrir, y cambiar de dominio no obliga a tocar el
// servidor.
const BASE_URL = import.meta.env.VITE_API_URL || "";

const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 15_000,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default apiClient;